import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@restart/ui/esm/Button';
import React from 'react'
import { Card } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

export default function Container(props) {
    const { obj } = props;
    const { img } = obj;
    const url = `/details/${obj.id}`;
    const handleClick = (obj) => {

    }
    return (
        <Card style={{ width: '18rem' }} className="me-3 mb-3 border-3 border-info rounded">
            <Card.Img variant="top" src={img} className="pt-2 border rounded-circle" />
            <Card.Body>
                <Card.Title>{obj.name ? obj.name : obj.title}</Card.Title>
                <Card.Text>
                    <h5>
                        {obj.comment?`Course : ${obj.course}`:""}
                    </h5>
                    {obj.details ? obj.details:""} <br/>
                    {obj.comment ? `Review: ${obj.comment} `  : <br />}
                    <h4 className="text-bold pt-2">
                        {obj.price ? `Price: ${obj.price}` : ""}
                    </h4>
                    {
                        obj.price?<div className="text-warning"><FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/></div> :""
                    }
                
                </Card.Text>
                {

                    obj.comment ? "" : <Link to={url}><Button>
                        See Details
                    </Button></Link>
                }

            </Card.Body>
        </Card>
    )
}
